import React from 'react';
import ReactDOM from 'react-dom/client';


import './assets/styles/index.css';
import './assets/fonts/font-awesome/css/all.min.css';
// import "assets/styles/tailwind.css";

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
